import K8ProgramPrimaryCTAContainer from './container'
export default K8ProgramPrimaryCTAContainer
